module.exports = __webpack_public_path__ + "img/i_empty.ac09ee7d.svg";